import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=270a624a&"
import script from "./TableList.vue?vue&type=script&lang=js&"
export * from "./TableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports